import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ContentSections, useContentBlocks } from '../components/content/ContentSections';
import { StaticPageLayout } from '../components/layout/StaticPageLayout';
import { PageMeta } from '../components/seo/PageMeta';
import { TELEGRAM_SUPPORT_URL } from '../utils/constants';

export function SiteFaqPage() {
  const { t } = useTranslation();
  const blocks = useContentBlocks('staticPages.siteFaq.blocks');

  return (
    <>
    <PageMeta
      title="Proxy FAQ | Rocket Proxy"
      description="Answers about buying proxies from Rocket Proxy: residential, mobile, ISP, datacenter, protocols, delivery, and billing."
      path="/faq"
    />
    <StaticPageLayout titleKey="staticPages.siteFaq.title" subtitleKey="staticPages.siteFaq.subtitle">
      <ContentSections blocks={blocks} />
      <div className="mt-8 rounded-2xl border border-brand-accent/30 bg-brand-accent/10 p-5 md:p-6">
        <h2 className="text-lg font-heading font-semibold text-brand-accent mb-2">
          {t('staticPages.siteFaq.moreTitle')}
        </h2>
        <p className="text-neutral-medium font-body mb-4">{t('staticPages.siteFaq.moreText')}</p>
        <a
          href={TELEGRAM_SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center h-11 px-5 rounded-full bg-brand-accent text-white font-heading font-semibold text-sm"
        >
          {t('staticPages.siteFaq.moreCta')}
        </a>
      </div>
      <div className="pt-4">
        <Link to="/" className="text-sm text-brand-accent font-heading font-semibold">
          {t('staticPages.backToHome')}
        </Link>
      </div>
    </StaticPageLayout>
    </>
  );
}
